import { useContext, useCallback } from "react";
import { FocusModalContext } from "./FocusModalContext.js";
import "../../utils/noOp.js";
function useFocusModals() {
  const { setRegisteredModals, setUnviewedCount } = useContext(FocusModalContext), flagAsViewed = useCallback(
    (uniqueIds, hasBeenViewed = !0) => {
      setRegisteredModals(
        (prev) => prev.map((m) => uniqueIds.includes(m.uniqueId) ? (!hasBeenViewed && !m.hasBeenCounted && setUnviewedCount((prev2) => prev2 + 1), { ...m, hasBeenViewed, hasBeenCounted: !0 }) : m)
      );
    },
    [setRegisteredModals, setUnviewedCount]
  ), updateProps = useCallback(
    (uniqueId, props) => {
      setRegisteredModals(
        (prev) => prev.map((m) => m.uniqueId !== uniqueId ? m : { ...m, ...props })
      );
    },
    [setRegisteredModals]
  );
  return {
    /**
     * Flags modals matching provided IDs with `hasBeenViewed`
     *
     * @param {boolean} hasBeenViewed - Defaults to `true`
     */
    flagAsViewed,
    updateProps
  };
}
export {
  useFocusModals
};
//# sourceMappingURL=useFocusModals.js.map
